import CONSTANT from "../../../Constant/Constant";

import {
    Menu,
    Paper,
    Stack,
    Box,
    Avatar,
    Typography,
    Fade,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
} from '@mui/material';
import popUpMessages from '../../../config/popUpMsg.json';
import {Link} from 'react-router-dom';
import { useState } from 'react';
import PopUpMsg from '../../merge-profile/popUpMsg'

/**
 * @param {Object} UserInfo - User's information (e.g access, id, name, email, and other metadata)
 * @param {string} splittedUsername - This information is just he users first and last name
 * @param {HTMLElement} anchorEl - element that the user clicked on
 * @param {()=> undefined} closeComponent - Closes the component when invoked.
 * @param {boolean} openHeaderDialog - When true, the normal header dialog will appear.
 * 
 * @description - This component is for both large and small screen sizes. When the screen is small, 
 * it will display the the dialog component for the user to see their details. Otherwise, it will 
 * show up as the normal header dialog when user clicks on avatar.
 * 
 */
export default function HeaderMenu({
    UserInfo,
    splittedUsername, 
    name, 
    anchorEl, 
    closeComponent,
    openHeaderDialog,
}){

    const open = Boolean(anchorEl);
    const [popMsg] = useState(popUpMessages.raiseAccess)
    const [popUpMessage, setPopUpMessage] = useState({ heading: '', message: '' })
    const [showPopup, setShowPopUp] = useState(false)

    const renderHTML = (html) => ({ __html: html });

    const onOK = () => {
        setPopUpMessage({heading: '', message: '' })
        setShowPopUp(false)
      }
    

    return (
        <>
            <Menu
                id='fade-menu'
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={closeComponent}
                TransitionComponent={Fade}
                sx={{zIndex:9001}}
                /* Z index in mui is very high! */
            >
                <Paper
                    sx={{padding: '20px 20px 0 20px'}}
                    elevation={0}
                >
                    <Stack direction='row' alignItems={'center'} gap={3}>
                        <Avatar className='bg-danger pointer'>{name}</Avatar>
                        <Box>
                            <Typography fontSize={'1.0rem'} variant='h6'>{splittedUsername}</Typography>
                            <Typography fontSize={'1rem'} className='text-muted my-1'>{UserInfo.user_id}</Typography>
                            <Typography fontSize={'1rem'} className='text-muted my-1'>
                                ({CONSTANT.ROLE_MAPPER[UserInfo.user_role]})
                                {
                                    (UserInfo.countries && UserInfo.countries.includes(CONSTANT.GLOBAL))?
                                    ' - Global Access':''
                                }
                            </Typography>
                        </Box>
                    </Stack>
                    <Stack marginTop={'10px'} direction={'row-reverse'} justifyContent={'space-between'}>                       
                        <Link to='/track-request'>
                            <Button
                                color='primary'
                                className='_wg-dynamic-text ms-2'
                                sx={{whiteSpace:'nowrap'}}
                                id="dcr-status"
                                onClick={closeComponent}
                            >
                                DCR status
                            </Button>
                        </Link>
                        {UserInfo.isUserApprover ? (
                            <Link to="/ecs-inbox">
                                <Button
                                color="primary"
                                className="_wg-dynamic-text ms-2"
                                sx={{ whiteSpace: "nowrap" }}
                                id="ecs-inbox"
                                onClick={closeComponent}
                                >
                                ECS Inbox
                                </Button>
                            </Link>):("")}                        
                    </Stack>
                </Paper>
            </Menu>
            <Dialog
                open={openHeaderDialog}
                onClose={closeComponent}
                TransitionComponent={Fade}
            >
                <DialogTitle textAlign={'center'} className="_wg-dynamic-text">
                    Profile Details
                </DialogTitle>
                <Paper 
                    elevation={0}
                    sx={{padding:'10px'}}
                >
                    <Stack 
                        direction={'column'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        textAlign={'center'}
                    >
                        <Avatar 
                            className="bg-danger pointer"
                            sx={{height:'75px', width:'75px', fontSize:'37px'}}
                            
                        >
                            {name}
                        </Avatar>
                        <p className="text-muted my-1">{splittedUsername}</p>
                        <p className="text-muted my-1">
                         ({CONSTANT.ROLE_MAPPER[UserInfo.user_role]})
                                {
                                    (UserInfo.countries && UserInfo.countries.includes(CONSTANT.GLOBAL))?
                                    ' - Global Access':''
                                }
                        </p>
                        <p className="text-muted my-1">{UserInfo.user_id}</p>
                    </Stack>
                </Paper>
                <DialogActions>
                    <Button
                        onClick={closeComponent}
                        className="_wg-dynamic-text"
                    >
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>

            {showPopup &&
                <PopUpMsg
                popUpMessage={popUpMessage}
                onOK={() => onOK()}
                />
            }
        </>

    );

}